import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GlassReplacement from "../pages/impact-glass-replacement/page";
import WindowHardwareRepair from "../pages/window-hardware-repair/page";
import WeatherstrippingSealing from "../pages/weatherstripping-sealing/page";
import WindowCleaningMaintenance from "../pages/window-cleaning-maintenance/page";
import SlidingDoorRepair from "../pages/sliding-door-repair/page";
import EmergencyBoardUp from "../pages/emergency-board-up/page";
import BrickellPage from "../pages/impact-windows-brickell/page";
import AventuraPage from "../pages/impact-windows-aventura/page";
import CoralGablesPage from "../pages/impact-windows-coral-gables/page";
import MiamiBeachPage from "../pages/impact-windows-miami-beach/page";
import CoconutGrovePage from "../pages/impact-windows-coconut-grove/page";
import DoralPage from "../pages/impact-windows-doral/page";
import KendallPage from "../pages/impact-windows-kendall/page";
import PinecrestPage from "../pages/impact-windows-pinecrest/page";
import BayHarborPage from "../pages/impact-windows-bay-harbor-islands/page";
import KeyBiscaynePage from "../pages/impact-windows-key-biscayne/page";
import SouthMiamiPage from "../pages/impact-windows-south-miami/page";
import NorthMiamiBeachPage from "../pages/impact-windows-north-miami-beach/page";
import BlogPage from "../pages/blog/page";
import BlogCostArticle from "../pages/blog/window-repair-cost-miami/page";
import BlogComparisonArticle from "../pages/blog/impact-windows-vs-shutters/page";
import BlogInsuranceArticle from "../pages/blog/insurance-discount-impact-windows/page";
import BlogCodesArticle from "../pages/blog/hvhz-code-noa-explained/page";
import BlogSaltAirArticle from "../pages/blog/salt-air-hardware-failure/page";
import ServiceAreasPage from "../pages/service-areas/page";
import ReviewsPage from "../pages/reviews/page";
import AccessibilityPage from "../pages/accessibility/page";
import PrivacyPolicyPage from "../pages/privacy-policy/page";
import TermsOfServicePage from "../pages/terms-of-service/page";
import LegalDisclaimerPage from "../pages/legal-disclaimer/page";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/glass-replacement/",
        element: <GlassReplacement />,
      },
      {
        path: "/window-hardware-repair/",
        element: <WindowHardwareRepair />,
      },
      {
        path: "/weatherstripping-sealing/",
        element: <WeatherstrippingSealing />,
      },
      {
        path: "/window-cleaning-maintenance/",
        element: <WindowCleaningMaintenance />,
      },
      {
        path: "/sliding-door-repair/",
        element: <SlidingDoorRepair />,
      },
      {
        path: "/emergency-board-up/",
        element: <EmergencyBoardUp />,
      },
      {
        path: "/impact-windows-brickell/",
        element: <BrickellPage />,
      },
      {
        path: "/impact-windows-aventura/",
        element: <AventuraPage />,
      },
      {
        path: "/impact-windows-miami-beach/",
        element: <MiamiBeachPage />,
      },
      {
        path: "/impact-windows-coral-gables/",
        element: <CoralGablesPage />,
      },
      {
        path: "/impact-windows-coconut-grove/",
        element: <CoconutGrovePage />,
      },
      {
        path: "/impact-windows-doral/",
        element: <DoralPage />,
      },
      {
        path: "/impact-windows-kendall/",
        element: <KendallPage />,
      },
      {
        path: "/impact-windows-pinecrest/",
        element: <PinecrestPage />,
      },
      {
        path: "/impact-windows-bay-harbor-islands/",
        element: <BayHarborPage />,
      },
      {
        path: "/impact-windows-key-biscayne/",
        element: <KeyBiscaynePage />,
      },
      {
        path: "/impact-windows-south-miami/",
        element: <SouthMiamiPage />,
      },
      {
        path: "/impact-windows-north-miami-beach/",
        element: <NorthMiamiBeachPage />,
      },
      {
        path: "/blog/",
        element: <BlogPage />,
      },
      {
        path: "/blog/window-repair-cost-miami/",
        element: <BlogCostArticle />,
      },
      {
        path: "/blog/impact-windows-vs-shutters/",
        element: <BlogComparisonArticle />,
      },
      {
        path: "/blog/insurance-discount-impact-windows/",
        element: <BlogInsuranceArticle />,
      },
      {
        path: "/blog/hvhz-code-noa-explained/",
        element: <BlogCodesArticle />,
      },
      {
        path: "/blog/salt-air-hardware-failure/",
        element: <BlogSaltAirArticle />,
      },
      {
        path: "/service-areas/",
        element: <ServiceAreasPage />,
      },
      {
        path: "/reviews/",
        element: <ReviewsPage />,
      },
      {
        path: "/accessibility/",
        element: <AccessibilityPage />,
      },
      {
        path: "/privacy-policy/",
        element: <PrivacyPolicyPage />,
      },
      {
        path: "/terms-of-service/",
        element: <TermsOfServicePage />,
      },
      {
        path: "/legal-disclaimer/",
        element: <LegalDisclaimerPage />,
      },
      // Spanish routes (same components)
      {
        path: "/es/",
        element: <Home />,
      },
      {
        path: "/es/reemplazo-de-vidrios/",
        element: <GlassReplacement />,
      },
      {
        path: "/es/reparacion-herrajes-ventanas/",
        element: <WindowHardwareRepair />,
      },
      {
        path: "/es/burletes-y-sellado/",
        element: <WeatherstrippingSealing />,
      },
      {
        path: "/es/limpieza-y-mantenimiento/",
        element: <WindowCleaningMaintenance />,
      },
      {
        path: "/es/reparacion-puertas-corredizas/",
        element: <SlidingDoorRepair />,
      },
      {
        path: "/es/tapiado-de-emergencia/",
        element: <EmergencyBoardUp />,
      },
      {
        path: "/es/ventanas-impacto-brickell/",
        element: <BrickellPage />,
      },
      {
        path: "/es/ventanas-impacto-aventura/",
        element: <AventuraPage />,
      },
      {
        path: "/es/ventanas-impacto-miami-beach/",
        element: <MiamiBeachPage />,
      },
      {
        path: "/es/ventanas-impacto-coral-gables/",
        element: <CoralGablesPage />,
      },
      {
        path: "/es/ventanas-impacto-coconut-grove/",
        element: <CoconutGrovePage />,
      },
      {
        path: "/es/ventanas-impacto-doral/",
        element: <DoralPage />,
      },
      {
        path: "/es/ventanas-impacto-kendall/",
        element: <KendallPage />,
      },
      {
        path: "/es/ventanas-impacto-pinecrest/",
        element: <PinecrestPage />,
      },
      {
        path: "/es/ventanas-impacto-bay-harbor-islands/",
        element: <BayHarborPage />,
      },
      {
        path: "/es/ventanas-impacto-key-biscayne/",
        element: <KeyBiscaynePage />,
      },
      {
        path: "/es/ventanas-impacto-south-miami/",
        element: <SouthMiamiPage />,
      },
      {
        path: "/es/ventanas-impacto-north-miami-beach/",
        element: <NorthMiamiBeachPage />,
      },
      {
        path: "/es/blog/",
        element: <BlogPage />,
      },
      {
        path: "/es/blog/costo-reparacion-ventanas-miami/",
        element: <BlogCostArticle />,
      },
      {
        path: "/es/blog/ventanas-impacto-vs-persianas/",
        element: <BlogComparisonArticle />,
      },
      {
        path: "/es/blog/descuento-seguro-ventanas-impacto/",
        element: <BlogInsuranceArticle />,
      },
      {
        path: "/es/blog/codigo-hvhz-noa-explicado/",
        element: <BlogCodesArticle />,
      },
      {
        path: "/es/blog/aire-salino-herrajes-miami/",
        element: <BlogSaltAirArticle />,
      },
      {
        path: "/es/areas-de-servicio/",
        element: <ServiceAreasPage />,
      },
      {
        path: "/es/historias/",
        element: <ReviewsPage />,
      },
      {
        path: "/es/accesibilidad/",
        element: <AccessibilityPage />,
      },
      {
        path: "/es/politica-de-privacidad/",
        element: <PrivacyPolicyPage />,
      },
      {
        path: "/es/terminos-de-servicio/",
        element: <TermsOfServicePage />,
      },
      {
        path: "/es/aviso-legal/",
        element: <LegalDisclaimerPage />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;